import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Clock } from "lucide-react";

const money = (n) => `$${Number(n || 0).toFixed(2)}`;
const wkLabel = (iso) => { const s = new Date(iso + "T12:00"); const e = new Date(s.getTime() + 6 * 86400000); const f = (d) => d.toLocaleDateString("en", { month: "short", day: "numeric" }); return `${f(s)} – ${f(e)}`; };

export const LateFeeReport = () => {
  const [r, setR] = useState(null);
  useEffect(() => { api.get("/admin/late-fees/report").then((x) => setR(x.data)).catch(() => {}); }, []);
  if (!r) return null;
  const t = r.totals;
  return (
    <div className="mt-8 bg-white rounded-2xl border border-coral/30 p-5" data-testid="late-fee-report">
      <div className="flex items-center gap-2 mb-3"><Clock className="w-5 h-5 text-coral" /><p className="font-display font-extrabold text-navy">Late Pickup Fees</p><span className="text-xs text-slate-400">$5/min after 5:30 PM</span></div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 mb-4">
        {[["Charged", t.charged, "text-navy", "late-total-charged"], ["Paid", t.paid, "text-emerald-600", "late-total-paid"], ["Outstanding", t.outstanding, "text-coral", "late-total-outstanding"], ["Waived", t.waived, "text-violet-600", "late-total-waived"]].map(([l, v, c, id]) => (
          <div key={l} className="rounded-xl bg-slate-50 p-3"><p className="text-[11px] text-slate-500">{l}</p><p className={`font-display font-extrabold text-xl ${c}`} data-testid={id}>{money(v)}</p></div>
        ))}
      </div>
      {!r.weeks.length ? <p className="text-sm text-slate-400">No late fees yet.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="late-fee-weeks">
            <thead className="text-xs text-slate-500 text-left"><tr><th className="py-2">Week</th><th>Late pickups</th><th>Minutes</th><th>Charged</th><th>Paid</th><th>Outstanding</th><th>Waived</th></tr></thead>
            <tbody>
              {r.weeks.map((w) => (
                <tr key={w.week_start} className="border-t border-slate-100" data-testid={`late-week-${w.week_start}`}>
                  <td className="py-2 font-semibold text-navy">{wkLabel(w.week_start)}</td><td>{w.count}</td><td>{w.minutes}</td>
                  <td>{money(w.charged)}</td><td className="text-emerald-600">{money(w.paid)}</td><td className="text-coral font-semibold">{money(w.outstanding)}</td><td className="text-violet-600">{money(w.waived)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
